import React from 'react'
import { connect } from 'react-redux'
import { downloadOrderAction } from '../../../../actions/appActions'
import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
} from '@material-ui/core/index'
import { strings } from '../../../../localization/strings'
import Loader from '../../../loaders/dots_loader/index'

class Component extends React.Component {
    state = { open: false, loading: false }

    handleClickOpen = () => {
        this.setState({ open: true })
        this.confirm()
    }

    handleClose = (force) => {
        if (force !== true) {
            if (this.state.loading) return
        }
        this.setState({ open: false, loading: false })
    }

    confirm = () => {
        this.setState({ loading: true })
        this.props
            .downloadOrderAction(this.props.orderId, true)
            .then(() => this.handleClose(true))
            .catch((error) => {
                this.handleClose(true)
                window.showDialog(error)
            })
    }

    render() {
        return (
            <div style={{ width: '100%' }}>
                <div onClick={this.handleClickOpen}>
                    {strings.printOrderButton}
                </div>

                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {strings.printOrderDialogTitle}
                    </DialogTitle>
                    <DialogContent />
                    <DialogActions />
                    {this.state.loading ? <Loader /> : null}
                </Dialog>
            </div>
        )
    }
}

const mapDispatchToProps = { downloadOrderAction }
const mapStateToProps = (store) => ({})
export default connect(mapStateToProps, mapDispatchToProps)(Component)
